//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import * as Yup from 'yup';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import Toast from '../../components/Toasts/Toast';
import { isSudo } from '../../helpers/permissions.helper';
import { clienteService } from '../../services/cliente.service';
import { defaultService } from '../../services/defaultService';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import { produtoService } from '../../services/produto.service';
import { userService } from '../../services/user.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import { produtoBloqueadoService } from '../../services/produtoBloqueado.service';

const validationSchema = Yup.object().shape({
  produto: Yup.object().required('Produto é obrigatório'),
  pontoAtendimentoIds: Yup.array()
    .min(1, 'Selecione ao menos um PA')
    .of(Yup.string().required()),
});

class ProdutoBloqueadoEdit extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    const user = userService.getCurrentUser();
    this.state = {
      entity: {
        produto: null,
        pontoAtendimentoIds: [],
        cliente: isSudo() ? null : user.cliente,
        atualizou: false,
      },
    };
  }
  componentDidMount() {
    const id = _.get(this.props.match, 'params.id');
    if (id) {
      produtoBloqueadoService.doGet(id).then(async (response) => {
        const data = response.data;
        console.log(data);

        const cliente = {
          codigoCliente: data.codigoCliente,
          nomeFantasia: data.nomeFantasia,
        };

        // Buscar produto pelo ID
        const produto = data.produto;

        // Buscar todos os PAs do cliente e filtrar os selecionados
        const allPAsResp = await pontoAtendimentoService.findAllByCliente(
          cliente
        );
        const allPAs = allPAsResp.data;
        const pontoAtendimentoSelecionados = allPAs.filter((pa) =>
          data.pontoAtendimentoIds.includes(pa.id)
        );

        this.setState({
          entity: {
            id: data.id,
            produto,
            pontoAtendimentoIds: pontoAtendimentoSelecionados, // <- array de objetos PA
            cliente,
          },
          atualizou: true,
        });
      });
    } else {
      this.setState({ atualizou: true });
    }
  }

  render() {
    const { entity, atualizou } = this.state;
    const isEdit = !!this.state.entity.id;

    const dadosCarregados = !!atualizou;

    console.log('this.state.entity', this.state.entity);

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Bloqueio de Produtos"
          subTitle=" "
          canBack={true}
        />
        <Formik
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize={true}
          onSubmit={(values, actions) => {
            const payload = {
              produtoId: values.produto.id,
              pontoAtendimentoIds: values.pontoAtendimentoIds.map(
                (pa) => pa.id
              ),
              codigoCliente: values.cliente.codigoCliente,
              nomeFantasia: values.cliente.nomeFantasia,
            };
            if (_.get(payload, '_links.self.href')) {
              _.set(
                payload,
                'id',
                defaultService.getIdFromUrl(_.get(payload, '_links.self.href'))
              );
            }

            produtoBloqueadoService
              .doSave(payload)
              .then(() => {
                actions.setSubmitting(false);
                this.props.success({
                  message: 'Produto bloqueado salvo com sucesso.',
                });
                this.props.history.push('/produtoBloqueado');
              })
              .catch((e) => {
                actions.setSubmitting(false);

                const mensagem =
                  _.get(e, 'response.data.detalhe') || 'Erro desconhecido.';

                this.props.error({
                  message: mensagem,
                });
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} noValidate>
              <div className="flex-column">
                <Toast />
                <div className="cardSeculus d-flex flex-column mb-0">
                  <div className="form-row">
                    {isSudo() && (
                      <div className="form-group col-md-6">
                        <FormSelectInput
                          name="cliente"
                          id="cliente"
                          label="Cliente"
                          placeholder="Selecione o cliente"
                          valueKey="codigoCliente"
                          labelKey="label"
                          required={true}
                          returnFullObject={true}
                          service={clienteService.findAll}
                          onChange={(name, value) => setFieldValue(name, value)}
                          value={values.cliente}
                          messageValidate={touched.cliente && errors.cliente}
                        />
                      </div>
                    )}
                    {values.cliente && dadosCarregados && (
                      <>
                        <div className="form-group col-md-6">
                          <FormSelectInput
                            key={
                              (values.cliente &&
                                values.cliente.codigoCliente) ||
                              'produto'
                            }
                            name="produto"
                            id="produto"
                            label="Produto"
                            placeholder="Selecione o produto"
                            labelKey="label"
                            valueKey="id"
                            parent={values.cliente}
                            disabled={!values.cliente}
                            required={true}
                            returnFullObject={true}
                            service={produtoService.findAll}
                            onChange={(name, value) => {
                              setFieldValue(name, value);
                            }}
                            value={values.produto}
                            messageValidate={_.get(errors, 'produto')}
                          />
                        </div>

                        <div className="form-group col-md-6">
                          <FormSelectInput
                            key={
                              (values.cliente &&
                                values.cliente.codigoCliente) ||
                              'pontoAtendimentoIds'
                            }
                            name="pontoAtendimentoIds"
                            id="pontoAtendimentoIds"
                            label="Pontos de Atendimento"
                            placeholder="Selecione os PAs"
                            valueKey="id"
                            labelKey="nome"
                            isMulti={true}
                            returnFullObject={true}
                            required={true}
                            searchable={true}
                            allowSelectAll={true}
                            parent={values.cliente}
                            disabled={!values.cliente}
                            service={pontoAtendimentoService.findAllByCliente}
                            defaultValue={
                              _.get(values, `pontoAtendimentoIds`)
                                ? _.get(values, `pontoAtendimentoIds`, [])
                                    .map((pa) => pa.nome)
                                    .join(', ')
                                : ''
                            }
                            onChange={(name, value) => {
                              console.log(value);

                              setFieldValue(name, value);
                            }}
                            value={values.pontoAtendimentoIds}
                            messageValidate={_.get(
                              errors,
                              'pontoAtendimentoIds'
                            )}
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <div
                    style={{ borderBottom: '1px solid #ccc', margin: '2rem 0' }}
                  />

                  <div className="d-flex flex-row flex-sm-row ">
                    <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                      <button
                        type="button"
                        className="btn btn-secondary btn30 white"
                        disabled={isSubmitting}
                        onClick={() => this.props.history.goBack()}
                      >
                        Cancelar
                      </button>
                    </div>

                    {isEdit && (
                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="button"
                          className="btn btn-danger btn30"
                          disabled={isSubmitting}
                          onClick={() => {
                            confirmAlert({
                              customUI: ({ onClose }) => (
                                <div className="custom-confirm-alert">
                                  <h2>Confirmar exclusão</h2>
                                  <p>
                                    Você tem certeza que deseja excluir este
                                    Produto bloqueado?
                                  </p>
                                  <div className="d-flex justify-content-around mt-4">
                                    <button
                                      className="btn btn-secondary btn30 white"
                                      onClick={onClose}
                                    >
                                      Não
                                    </button>
                                    <button
                                      className="btn btn-danger btn30"
                                      onClick={async () => {
                                        try {
                                          await produtoBloqueadoService.doDelete(
                                            values.id
                                          );
                                          this.props.success({
                                            message:
                                              'Produto Bloqueado excluído com sucesso.',
                                          });
                                          this.props.history.push(
                                            '/produtoBloqueado'
                                          );
                                          onClose();
                                        } catch (e) {
                                          console.error(e);
                                          this.props.error({
                                            message:
                                              'Erro ao excluir o Ponto de Atendimento.',
                                          });
                                          onClose();
                                        }
                                      }}
                                    >
                                      Sim
                                    </button>
                                  </div>
                                </div>
                              ),
                            });
                          }}
                        >
                          Excluir
                        </button>
                      </div>
                    )}
                    <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                      <button
                        type="submit"
                        className="btn btn-secondary btn30 green"
                        disabled={isSubmitting}
                      >
                        {isEdit ? 'Salvar Alterações' : 'Salvar'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return { user };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  { forwardRef: true }
)(ProdutoBloqueadoEdit);
